<div class="row form-group">
  <label class="control-label col-4">{{'Tài khoản mới' | translate}}</label>
  <div class="col-8 required-field">
    <input type="text" class="form-control" [(ngModel)]="TaiKhoan">
  </div>
</div>

<div class="row form-group">
  
</div>

<div class="modal-footer" style="display: flex;justify-content: space-between;">
  <div style="display:flex;">
    <!--<div class="checkbox c-checkbox"> password
    <label>
      <input tabIndex="20" type="checkbox" [(ngModel)]="doituongSelect.TrangThaiXuLy" />
      <span class="fa fa-check"></span> Đã xử lý xong
    </label>
  </div>-->
  </div>
  <div class="">
    <button class="mb-1 mr-1 btn btn-secondary" (click)="closeModal()" title="Ấn ESC để thoát" style="padding-top:0px !important">Hủy bỏ</button>
    <button  type="submit" (click)="DoiMatKhau()" title="Ấn F9 để lưu" class="mb-1 mr-1 btn btn-primary" style="padding-top:0px !important">Lưu lại</button>
  </div>

</div>


